import React, { useEffect, useState } from 'react';
import { css, cx } from 'linaria';
const fadeStyle = "f1puhe4v";
export const Fade = ({
  show,
  remove,
  children
}) => {
  const [render, setRender] = useState(show);
  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) {
      setRender(false);
      remove();
    }
  };

  const fadeClass = cx(fadeStyle, show && 'fadeIn', !show && 'fadeOut');
  return render && <div className={fadeClass} onAnimationEnd={onAnimationEnd}>
        {children}
      </div>;
};

require("./fade.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./fade.js");